import React, { useState } from 'react';
import { InstagramIcon, LinkedinIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
export function EditorialContact() {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    if (!data.get('name') || !data.get('email') || !data.get('message')) {
      setError('Completá nombre, email y mensaje para enviarnos tu consulta.');
      return;
    }
    setError('');
    setSent(true);
    e.currentTarget.reset();
  };
  return <>
      <section id="contacto" className="grid lg:grid-cols-2" data-id="element-64">
        <div className="bg-[#1A1A1A] px-7 py-20 text-white md:px-16 lg:px-24" data-id="element-65">
          <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#d88b67]" data-id="element-66">
            Contacto
          </p>
          <h2 className="font-editorial mt-5 max-w-md text-5xl leading-tight" data-id="element-67">
            ¿Tenés un proyecto en mente?
          </h2>
          <p className="mt-6 max-w-sm text-sm leading-7 text-white/65" data-id="element-68">
            Contame tu idea. La primera consulta es sin cargo.
          </p>
          <div className="mt-12 space-y-5 text-sm text-white/80" data-id="element-69">
            <p className="flex gap-3" data-id="element-70">
              <MailIcon size={18} className="text-[#C4724A]" data-id="element-71" />
              hola@mariavictoriacorbalan.arq
            </p>
            <p className="flex gap-3" data-id="element-72">
              <PhoneIcon size={18} className="text-[#C4724A]" data-id="element-73" />
              +598 99 555 019
            </p>
            <p className="flex gap-3" data-id="element-74">
              <InstagramIcon size={18} className="text-[#C4724A]" data-id="element-75" />
              @mariavictoriacorbalan.arq
            </p>
            <p className="flex gap-3" data-id="element-76">
              <MapPinIcon size={18} className="text-[#C4724A]" data-id="element-77" />
              Montevideo, Uruguay
            </p>
          </div>
        </div>
        <div className="bg-[#F7F4EF] px-7 py-20 md:px-16 lg:px-24" data-id="element-78">
          <h2 className="font-editorial text-3xl" data-id="element-79">Hablemos de tu idea</h2>
          {sent && <p role="status" className="mt-5 bg-[#e5eee2] p-4 text-sm text-[#405238]" data-id="element-80">
              Gracias por escribir. Te responderemos a la brevedad.
            </p>}
          {error && <p role="alert" className="mt-5 text-sm text-[#a34d31]" data-id="element-81">
              {error}
            </p>}
          <form noValidate onSubmit={submit} className="mt-6 grid gap-5" data-id="element-82">
            <label className="text-xs font-bold" data-id="element-83">
              Nombre completo
              <input name="name" className="input-field" data-id="element-84" />
            </label>
            <label className="text-xs font-bold" data-id="element-85">
              Email
              <input name="email" type="email" className="input-field" data-id="element-86" />
            </label>
            <label className="text-xs font-bold" data-id="element-87">
              Teléfono <span className="font-normal" data-id="element-88">(opcional)</span>
              <input name="phone" className="input-field" data-id="element-89" />
            </label>
            <label className="text-xs font-bold" data-id="element-90">
              Tipo de proyecto
              <select name="type" className="input-field" data-id="element-91">
                <option data-id="element-92">Vivienda</option>
                <option data-id="element-93">Reforma</option>
                <option data-id="element-94">Local</option>
                <option data-id="element-95">Interiores</option>
                <option data-id="element-96">Otro</option>
              </select>
            </label>
            <label className="text-xs font-bold" data-id="element-97">
              Mensaje
              <textarea name="message" rows={3} className="input-field resize-none" placeholder="Contame un poco sobre tu idea..." data-id="element-98" />
            </label>
            <button className="mt-3 bg-[#C4724A] py-4 text-xs font-bold uppercase tracking-wider text-white hover:bg-[#a95d3b]" data-id="element-99">
              Enviar consulta
            </button>
          </form>
        </div>
      </section>
      <footer className="bg-[#1A1A1A] px-5 py-12 text-white md:px-10" data-id="element-100">
        <div className="mx-auto flex max-w-[1440px] flex-col gap-8 md:flex-row md:items-center md:justify-between" data-id="element-101">
          <div data-id="element-102">
            <p className="font-editorial text-2xl" data-id="element-103">VC Estudio</p>
            <p className="mt-2 text-xs text-white/50" data-id="element-104">
              Arquitectura que transforma formas de vivir.
            </p>
          </div>
          <nav className="flex gap-5 text-xs text-white/70" data-id="element-105">
            <a href="#inicio" data-id="element-106">Inicio</a>
            <a href="#proyectos" data-id="element-107">Proyectos</a>
            <a href="#contacto" data-id="element-108">Contacto</a>
          </nav>
          <div className="flex gap-4" data-id="element-109">
            <InstagramIcon size={18} data-id="element-110" />
            <LinkedinIcon size={18} data-id="element-111" />
          </div>
        </div>
        <div className="mx-auto mt-10 flex max-w-[1440px] justify-between border-t border-white/15 pt-5 text-[10px] text-white/40" data-id="element-112">
          <span data-id="element-113">© 2025 María Victoria Corbalan</span>
          <span data-id="element-114">Diseñado con intención</span>
        </div>
      </footer>
    </>;
}